import React from 'react';

const UnReadMessageSVG = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.2 1H11.8C12.46 1 13 1.54 13 2.2V9.4C13 10.06 12.46 10.6 11.8 10.6H3.4L1 13V2.2C1 1.54 1.54 1 2.2 1ZM6.4 2.8H7.6V6.4H6.4V2.8ZM7.6 7.6H6.4V8.8H7.6V7.6Z"
      className="notification-SVG"
    />
  </svg>
);

const RecentIconSVG = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.12376 7.71299C4.12376 7.50407 4.12376 7.26303 4.12376 7.02199C4.12376 6.28185 4.10392 5.54107 4.1311 4.802C4.17396 3.6002 4.74982 2.76347 5.74695 2.24905C5.87335 2.18374 5.93249 2.12524 5.9432 1.96206C5.98547 1.3168 6.6536 0.862169 7.27549 1.03811C7.72871 1.16576 8.02319 1.53572 8.06327 2.04099C8.07101 2.13821 8.10514 2.18076 8.1867 2.21693C9.18998 2.66369 9.89522 3.71061 9.87339 4.94368C9.85732 5.82849 9.86962 6.71415 9.86922 7.59938C9.86922 7.64683 9.86922 7.69448 9.86922 7.70831C10.1073 7.82511 10.3334 7.91084 10.5346 8.04104C10.8501 8.24528 11.012 8.55589 10.9993 8.96223C10.9926 9.17497 10.9993 9.38772 10.9993 9.60046C10.9981 9.86299 10.8765 9.99915 10.6362 9.99936C8.20879 10.0002 5.78128 10.0002 3.35364 9.99936C3.13635 9.99936 3.01074 9.88044 3.00538 9.64812C2.99844 9.34389 2.99447 9.03775 3.01769 8.73502C3.04269 8.41228 3.23041 8.18188 3.48083 8.02594C3.67609 7.90403 3.89397 7.82255 4.12376 7.71299Z"
      className="notification-SVG"
    />
    <path
      d="M7.82667 11C7.93833 11.0144 8.00235 11.0749 7.99993 11.1707C7.99137 11.4973 7.80229 11.7344 7.46861 11.8784C7.32587 11.9401 7.15856 11.9608 7.00335 12C6.45025 11.9754 5.97773 11.5919 6.00081 11.1716C6.00584 11.0799 6.05404 11.0183 6.15919 11.0017"
      className="notification-SVG"
    />
  </svg>
);

const SubstractionIconSVG = () => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6 12C9.31371 12 12 9.31371 12 6C12 2.68629 9.31371 0 6 0C2.68629 0 0 2.68629 0 6C0 9.31371 2.68629 12 6 12ZM3.47276 5.05078C2.94954 5.05078 2.52539 5.47493 2.52539 5.99815C2.52539 6.52137 2.94954 6.94552 3.47276 6.94552H8.52539C9.04861 6.94552 9.47276 6.52137 9.47276 5.99815C9.47276 5.47493 9.04861 5.05078 8.52539 5.05078H3.47276Z"
      fill="#CC0000"
    />
  </svg>
);

const CheckMarkSVG = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9 0C4.03125 0 0 4.03125 0 9C0 13.9688 4.03125 18 9 18C13.9688 18 18 13.9688 18 9C18 4.03125 13.9688 0 9 0ZM13.6312 6.825L8.34375 12.1312C8.175 12.3 7.93125 12.4125 7.6875 12.4125C7.44375 12.4125 7.2 12.3187 7.03125 12.1312L4.36875 9.46875C3.99375 9.09375 3.99375 8.5125 4.36875 8.1375C4.74375 7.7625 5.325 7.7625 5.7 8.1375L7.6875 10.125L12.3187 5.49375C12.6937 5.11875 13.275 5.11875 13.65 5.49375C14.0063 5.86875 14.0062 6.45 13.6312 6.825Z"
      className="logout-success-svg"
    />
  </svg>
);

const ExclamationErrorSVG = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9 0C7.21997 0 5.47991 0.527841 3.99987 1.51677C2.51983 2.50571 1.36628 3.91131 0.685088 5.55585C0.00389957 7.20038 -0.17433 9.00998 0.172936 10.7558C0.520203 12.5016 1.37737 14.1053 2.63604 15.364C3.89471 16.6226 5.49836 17.4798 7.24419 17.8271C8.99002 18.1743 10.7996 17.9961 12.4442 17.3149C14.0887 16.6337 15.4943 15.4802 16.4832 14.0001C17.4722 12.5201 18 10.78 18 9C18 6.61305 17.0518 4.32387 15.364 2.63604C13.6761 0.948212 11.387 0 9 0ZM9 14.0625C8.7775 14.0625 8.55999 13.9965 8.37498 13.8729C8.18998 13.7493 8.04579 13.5736 7.96064 13.368C7.87549 13.1624 7.85321 12.9362 7.89662 12.718C7.94003 12.4998 8.04717 12.2993 8.20451 12.142C8.36184 11.9847 8.5623 11.8775 8.78053 11.8341C8.99875 11.7907 9.22496 11.813 9.43052 11.8981C9.63609 11.9833 9.81179 12.1275 9.93541 12.3125C10.059 12.4975 10.125 12.715 10.125 12.9375C10.125 13.2359 10.0065 13.522 9.7955 13.733C9.58452 13.944 9.29837 14.0625 9 14.0625ZM10.125 10.125H7.875V3.9375H10.125V10.125Z"
      className="exclamationCircle-SVG"
    />
  </svg>
);

const InformativeSVG = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9 18C10.78 18 12.5201 17.4722 14.0001 16.4832C15.4802 15.4943 16.6337 14.0887 17.3149 12.4442C17.9961 10.7996 18.1743 8.99002 17.8271 7.24419C17.4798 5.49836 16.6226 3.89471 15.364 2.63604C14.1053 1.37737 12.5016 0.520202 10.7558 0.172935C9.00998 -0.174332 7.20038 0.00389768 5.55585 0.685086C3.91131 1.36627 2.50571 2.51983 1.51677 3.99987C0.527843 5.47991 9.4242e-07 7.21997 7.86805e-07 9C5.78131e-07 11.3869 0.94821 13.6761 2.63604 15.364C4.32387 17.0518 6.61305 18 9 18ZM9 3.9375C9.2225 3.9375 9.44001 4.00348 9.62502 4.1271C9.81002 4.25071 9.95422 4.42642 10.0394 4.63198C10.1245 4.83755 10.1468 5.06375 10.1034 5.28198C10.06 5.50021 9.95283 5.70066 9.79549 5.858C9.63816 6.01533 9.4377 6.12248 9.21948 6.16589C9.00125 6.20929 8.77505 6.18701 8.56948 6.10187C8.36391 6.01672 8.18821 5.87252 8.0646 5.68752C7.94098 5.50251 7.875 5.28501 7.875 5.0625C7.875 4.76413 7.99353 4.47798 8.2045 4.26701C8.41548 4.05603 8.70163 3.9375 9 3.9375ZM7.875 7.875L10.125 7.875L10.125 14.0625L7.875 14.0625L7.875 7.875Z"
      className="InformativeCircle-SVG"
    />
  </svg>
);

const WarningSVG = () => (
  <svg
    width="18"
    height="16"
    viewBox="0 0 18 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.95312 0.000856623C8.78462 0.0082579 8.62077 0.0569499 8.47677 0.142414C8.33277 0.227878 8.21327 0.347345 8.12936 0.489741L0.13287 13.9713C0.0453947 14.1197 -0.000428239 14.2878 3.0161e-06 14.4588C0.000434271 14.6299 0.0471045 14.7978 0.135327 14.9458C0.223549 15.0937 0.350216 15.2164 0.502608 15.3017C0.655 15.3869 0.82775 15.4316 1.00351 15.4313H16.9965C17.1723 15.4316 17.345 15.3869 17.4974 15.3017C17.6498 15.2164 17.7765 15.0937 17.8647 14.9458C17.9529 14.7978 17.9996 14.6299 18 14.4588C18.0004 14.2878 17.9546 14.1197 17.8671 13.9713L9.86394 0.489741C9.77267 0.334903 9.63946 0.207434 9.47885 0.121224C9.31823 0.0350136 9.13638 -0.00662472 8.95312 0.000856623ZM9 4.28708C9.47344 4.28708 9.85725 4.67089 9.85725 5.14433L9.64293 9.00195C9.64293 9.35702 9.35508 9.64488 9 9.64488C8.64492 9.64488 8.35707 9.35702 8.35707 9.00195L8.14275 5.14433C8.14275 4.67089 8.52656 4.28708 9 4.28708ZM9 10.7164C9.5918 10.7164 10.0716 11.1962 10.0716 11.788C10.0716 12.3798 9.5918 12.8596 9 12.8596C8.4082 12.8596 7.92844 12.3798 7.92844 11.788C7.92844 11.1962 8.4082 10.7164 9 10.7164Z"
      className="warningTriangle-SVG"
    />
  </svg>
);

export {
  UnReadMessageSVG,
  RecentIconSVG,
  SubstractionIconSVG,
  CheckMarkSVG,
  ExclamationErrorSVG,
  InformativeSVG,
  WarningSVG,
};
